import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import CMMessageContent from '../components/CMMessageContent'; 
import axios from 'axios'; 

import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import { api_base_url, base_url} from '../common/Constants';
 
class CMMessage extends React.Component{

    constructor(){
        super(); 
    }
 
    render()
    {
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="page-wrapper">
                <Header/> 
                 <Helmet>
                    <title>{metas[4].title}</title>  
                    <meta name="description" content={metas[4].meta_description} />
                    <meta name="keywords" content={metas[4].meta_title} />
                    <meta property="og:image" content={content[10].image}  />
                    <link rel="canonical" href={base_url+'chairmans-message'} />
                </Helmet>
                <PageHeader title="Chairman's Message"/>
                <CMMessageContent content={JSON.parse(localStorage.getItem("content"))} awards={JSON.parse(localStorage.getItem("awards"))}/>  
                <Footer/>
            </div>
       
        )
    }

}
export default CMMessage;